import { login, getSidebarMenu,getSidebarMenu_S, getInfo,refreshToken } from '@/api/login';
import {setFullName, getToken, setToken, removeToken,setDisplayName,getDisplayName, removeDisplayName,setcurStoreId,getcurStoreId,removecurStoreId,setRefreshToken,getRefreshToken,
  setAdminName,getAdminName,removeAdminName,setClaim,setPersonnelId} from '@/utils/auth';
import { formatError } from '@/utils/index';
import { errorNot } from '@/utils/message';

/*  function formatServerMenus(sMeuns) {
	let menus = [];
	sMeuns.forEach(function(val, idx, arr) {
		menus = menus.concat(val.SiteMapNode);
	})
	return menus;
} */

const user = {
  state: {
    token: getToken(),
    userinfo: {},
    roles: [],
    menus: [],
    goodsNorms:{}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO: (state, userinfo) => {
      state.userinfo = userinfo;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus;
    },
    GET_ROW:(state,row) =>{
      console.log(row)
      state.goodsNorms = row;
    }
  },

  actions: {
    // 登录
    Login({
      dispatch,commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          setRefreshToken(response.refresh_token);
          setToken(response.access_token);
          commit('SET_TOKEN', response.access_token);
          // console.log(response.refresh_token)
          resolve();
          var expires_in = Number(response.expires_in) * 1000;
          timeInter = setInterval(function(){     //10秒后 持续获取新token
            refreshToken(getToken(), getRefreshToken()).then(response => {
                commit('SET_TOKEN', response.access_token);
                setRefreshToken(response.refresh_token);
            }).catch(error => {
              errorNot(formatError(error.data.error));
              reject(error);
              return dispatch('FedLogOut').then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
              })
              commit('FedLogOut');
              // this.dispatch('FedLogOut').then(() => {
              //   location.reload(); // 为了重新实例化vue-router对象 避免bug
              // })
              
            });
          },expires_in)
        }).catch(error => {
          // if(error){
          //   if(error.data.error == 'invalid_grant'){
          //     errorNot('请检查输入的账号密码是否正确');
          //   }
          // }
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(responses => {
          // if(responses.role == 'admin' || responses.role == 'storeAdmin' || !(responses.role == 'shoppingGuider')){
              if(responses.role == 'admin'){
                setAdminName(responses.role)
              }
              getSidebarMenu().then(data => {
                /* let menus = formatServerMenus(responses.AdminMenu);*/
                if(responses.role == 'storeAdmin'){
                  data.displayName = '1';
                  setDisplayName(data.displayName)
                }
                setcurStoreId(responses.storeIds);
                setFullName(responses.fullName);
                setPersonnelId(responses.personnelId);
                setClaim(responses.userClaims);
                const menus = data.siteMapNode;
                commit('SET_USERINFO', {
                  userId: responses.userId,
                  roleName: responses.roleName,
                  userName: responses.userName,
                  role: responses.role,
                  fullName: responses.fullName
                });
                commit('SET_ROLES', responses.userClaims);
                commit('SET_MENUS', menus);
                resolve(responses);
              });
          // }
          // else{
          //     this.dispatch('FedLogOut').then(() => {
          //       errorNot('导购无权限登录')
          //       setTimeout(function(){
          //         location.reload(); 
          //       },1200)
          //     })
          // }
          
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        removeDisplayName();
        removecurStoreId();
        removeAdminName();
        commit('SET_TOKEN', '');
        commit('SET_USERINFO', {});
        removeToken();
        resolve();
        clearInterval(timeInter);
      });
    }
  }
};

export default user;


// WEBPACK FOOTER //
// ./src/store/modules/user.js